import { ChatlobbyActionType } from '../../types/chatlobbyReducerType'

export const setUpChatlobby = (data : any) => {
    return {type: ChatlobbyActionType.SET_UP_CHATLOBBY, payload: data}
}

export const addToChatlobby = (data : any) => {
    return {type: ChatlobbyActionType.UPDATE_CHATLOBBY, payload: data}
}
